export default {
  'menu.users': 'User Center',
  'pages.users.action.detail': 'Detail',
  'pages.users.action.refresh': 'Refresh',
  'pages.users.column.action': 'Action',
  'pages.users.column.amBitId': 'AmBit ID',
  'pages.users.column.createdAt': 'Created at',
  'pages.users.column.displayId': 'Display ID',
  'pages.users.column.gender': 'Gender',
  'pages.users.column.nickname': 'Nickname',
  'pages.users.column.region': 'Region',
  'pages.users.column.showId': 'Show ID',
  'pages.users.column.status': 'Status',
  'pages.users.column.tier': 'Tier',
  'pages.users.column.timStatus': 'TIM status',
  'pages.users.column.uid': 'UID',
  'pages.users.column.updatedAt': 'Updated at',
  'pages.users.column.userId': 'User ID',
  'pages.users.column.vipLevel': 'VIP level',
  'pages.users.detail.field.accountStatus': 'Account status',
  'pages.users.detail.field.agentAtName': 'Agent @ name',
  'pages.users.detail.field.amBitId': 'AmBit ID',
  'pages.users.detail.field.avatarUrl': 'Avatar URL',
  'pages.users.detail.field.bio': 'Bio',
  'pages.users.detail.field.birthday': 'Birthday',
  'pages.users.detail.field.c2cMuteSeconds': 'C2C mute seconds',
  'pages.users.detail.field.complaintCount': 'Complaint count',
  'pages.users.detail.field.createdAt': 'Created at',
  'pages.users.detail.field.did': 'DID',
  'pages.users.detail.field.gender': 'Gender',
  'pages.users.detail.field.groupMuteSeconds': 'Group mute seconds',
  'pages.users.detail.field.identityId': 'Identity ID',
  'pages.users.detail.field.nickname': 'Nickname',
  'pages.users.detail.field.onlineStatus': 'Online status',
  'pages.users.detail.field.pushId': 'Push ID',
  'pages.users.detail.field.region': 'Region',
  'pages.users.detail.field.reportedCount': 'Reported count',
  'pages.users.detail.field.showId': 'Show ID',
  'pages.users.detail.field.status': 'Status',
  'pages.users.detail.field.timStatus': 'TIM status',
  'pages.users.detail.field.tmId': 'TM ID',
  'pages.users.detail.field.trtcId': 'TRTC ID',
  'pages.users.detail.field.updatedAt': 'Updated at',
  'pages.users.detail.field.userId': 'User ID',
  'pages.users.detail.field.vipLevel': 'VIP level',
  'pages.users.detail.field.wId': 'W ID',
  'pages.users.detail.profile': 'Profile',
  'pages.users.detail.risk': 'Risk',
  'pages.users.detail.tim': 'TIM',
  'pages.users.detail.timMute': 'TIM mute',
  'pages.users.detail.timStatus': 'TIM status',
  'pages.users.detail.title': 'User Detail: {uid}',
  'pages.users.empty.detail': 'No data',
  'pages.users.gender.female': 'Female',
  'pages.users.gender.male': 'Male',
  'pages.users.gender.unknown': 'Unknown',
  'pages.users.message.missingUid': 'Missing user UID',
  'pages.users.search.compatSearch': 'Legacy search',
  'pages.users.search.createdRange': 'Created time',
  'pages.users.search.isBanned': 'Banned',
  'pages.users.search.keyword': 'Keyword',
  'pages.users.search.sort': 'Sort',
  'pages.users.search.status': 'Status',
  'pages.users.search.tier': 'Tier',
  'pages.users.search.timStatus': 'TIM status',
  'pages.users.search.vipLevel': 'VIP level',
  'pages.users.sort.createdAsc': 'Created asc',
  'pages.users.sort.createdDesc': 'Created desc',
  'pages.users.sort.updatedDesc': 'Updated desc',
  'pages.users.status.banned': 'Banned',
  'pages.users.status.normal': 'Normal',
  'pages.users.timStatus.abnormal': 'Abnormal',
  'pages.users.timStatus.normal': 'Normal',
  'pages.users.title': 'User Center',
};
